import { render, staticRenderFns } from "./EventMovie.vue?vue&type=template&id=39abe649&scoped=true&"
import script from "./EventMovie.vue?vue&type=script&lang=js&"
export * from "./EventMovie.vue?vue&type=script&lang=js&"
import style0 from "./EventMovie.vue?vue&type=style&index=0&id=39abe649&scoped=true&lang=css&"
import style1 from "./EventMovie.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39abe649",
  null
  
)

export default component.exports